'use strict';

angular.module('shiftTraderApp')
  .controller('FullscreenOverlayCtrl', function ($scope, security, $log, Session, Registration, ServerUrls, $http, Angularytics,
                                     $stateParams, $state, $uibModal, $rootScope, $timeout, HardNavigationService, toastr) {
    var resetState = function() {
      $scope.state = {
        currentView: $state.current.name,
        login: {
          show: $state.current.name === 'login',
          saveEmail: false,
          username: '',
          password: '',
          loginStarted: false
        },
        activateUser: {
          show: $state.current.name === 'activateUser',
          requestInvalid: false,
          requestSuccess: false
        },
        resetPasswordRequest: {
          show: false,
          resetSent: false,
          resetInvalid: false,
          username: ''
        },
        resetPasswordSubmission: {
          show: $state.current.name === 'resetPassword',
          requestSent: false,
          requestInvalid: false,
          requestSuccess: false,
          password: '',
          passwordConfirmation: ''
        }
      };

      //If email query parameter given, fill out the form!
      if (angular.isDefined($stateParams.email)) {
        $scope.state.login.username = $stateParams.email;
      } else if (!_.isUndefined(Session.getEmailForLogin())) {
        $scope.state.login.username = Session.getEmailForLogin();
        $scope.emailLoadedFromStorage = Session.getEmailForLogin();
        $scope.state.login.saveEmail = true;
      }
    };

    resetState();

    // reset state when the $state changes -- need this because resetPassword $stateChange isn't until after
    //   page has instantiated the controller
    $scope.$on('$stateChangeSuccess', function() {
      resetState();

      // if we transition to any of these pages, just clear the session to make things easier!
      if (_.contains(['login', 'activateUser', 'resetPassword'], $scope.state.currentView)) {
        Session.clearSession();
      }
    });


    $scope.transitionView = function(viewName) {
      var viewAlias = $scope.state.currentView;

      if ($scope.state.currentView === 'resetPassword') {
        viewAlias = 'resetPasswordSubmission'
      }

      $scope.state[viewAlias].show = false;
      $scope.state.currentView = viewName;
      $scope.state[viewName].show = true;

      if (viewName === 'resetPasswordRequest') {
        $scope.state.resetPasswordRequest.username = $scope.state.login.username;
      }
    };

    $scope.login = function (username, password) {
      if($scope.state.login.saveEmail &&
          $scope.emailLoadedFromStorage !== $scope.state.login.username) {
        Session.saveEmailForLogin($scope.state.login.username);
      }

      $scope.state.login.loginStarted = true;

      security.login(username, password)
        .then(function() {
          Angularytics.trackEvent('Session', 'login-success');
          console.log('successful login');
          $scope.state.login.loginStarted = false;
          $rootScope.logoutCalled = false;
          $rootScope.transitionPageState('', 1000);

          $timeout(function() {
            resetState();
          }, 1000);
        }, function(response) {
          if (response.status === 401) {
            if (response.data.error === 'account_inactive_error') {
              $scope.status = 'accountInactive';
              toastr.error('Login denied. Your account is currently inactive.', 'Account Inactive');
            } else if (response.data.error === 'employee_activation_feature_not_enabled') {
              $scope.status = 'employeeActivationNotEnabled';
              toastr.error('Your store is now on the Shift Agent Basic plan. Please contact your manager for your schedule.', 'Error');
            } else {
              console.log('incorrect username or password');
              $scope.status = 'credFail';
              toastr.error('Incorrect user or password', 'Error');
            }

            $scope.state.login.loginStarted = false;

          } else if (response.status > 401 || response.status === 400) {
            console.log('server problems');
            toastr.error('Sorry! Server issue...', 'Error');
            $scope.state.login.loginStarted = false;
          }
        });
    };

    $scope.sendResetPassword = function() {
      Angularytics.trackEvent('Session', 'reset-password');
      if ($scope.resetForm.loginEmailReset.$valid) {
        var data = {
          user: {
            email: $scope.state.resetPasswordRequest.username
          }
        };
        return $http.post(ServerUrls.current.railsApi + 'users/password.json', data)
          .then(function() {
            $scope.state.resetPasswordRequest.resetSent = true;
            toastr.success('Password reset email has been sent to ' + data.user.email, 'Success');
            $timeout(function() {
              $scope.state.login.username = $scope.state.resetPasswordRequest.username;
              $scope.state.login.password = '';
              $scope.transitionView('login');
            }, 2000);
          }, function() {
            toastr.error('We couldn\'t reset your password. Is that the correct email address?', 'Error');
          });
      } else {
        $scope.state.resetPasswordRequest.resetInvalid = true;
        toastr.error('Invalid e-mail address specified for Forgot Password? request', 'Error');
      }
    };
    $scope.state.resetPasswordRequest.resetInvalid = false;


    $scope.submitNewPassword = function() {
      if ($scope.resetFormSubmission.$valid &&
        $scope.state.resetPasswordSubmission.password === $scope.state.resetPasswordSubmission.passwordConfirmation) {
        var data = {
          user: {
            reset_password_token: $stateParams.resetCode,
            password: $scope.state.resetPasswordSubmission.password,
            password_confirmation: $scope.state.resetPasswordSubmission.passwordConfirmation
          },
          reset_password_token: $stateParams.resetCode,
          abc: $stateParams.resetCode
        };
        return $http.put(ServerUrls.current.railsApi + 'users/password.json', data)
          .then(function(response) {
            $scope.state.resetPasswordSubmission.requestSent = true;
            if (response.status === 204) {
              toastr.success('Password reset successfully! Try logging in with your new password.', 'Success');
              $scope.state.resetPasswordSubmission.requestSuccess = true;
              $rootScope.authFailureOccurred = false;
              $timeout(function() {
                HardNavigationService.navigateTo('login', true);
              }, 1000);
            } else {
              toastr.error('Experienced an error while resetting your password. Is this the latest email link?', 'Error');
              $scope.state.resetPasswordSubmission.requestInvalid = true;
            }
            $scope.state.resetPasswordSubmission.password = '';
            $scope.state.resetPasswordSubmission.passwordConfirmation = '';
            return response;
          }, function() {
            toastr.error('Experienced an error while resetting your password. Is this the latest email link?', 'Error');
            $scope.state.resetPasswordSubmission.password = '';
            $scope.state.resetPasswordSubmission.passwordConfirmation = '';
          });
      } else {
        toastr.error('Password\'s must match. Please confirm that they match.', 'Error');
      }
    };

    $scope.activateUser = function() {
      if ($scope.activateUserForm.$valid &&
        $scope.state.activateUser.password === $scope.state.activateUser.passwordConfirmation) {
        var data = {
          user: {
            activation_code: $stateParams.activationCode,
            password: $scope.state.activateUser.password,
            password_confirmation: $scope.state.activateUser.passwordConfirmation
          }
        };

        $scope.state.activateUser.requestSent = true;
        return $http.put(ServerUrls.current.railsApi + 'registrations/', data)
          .then(function(response) {
            Angularytics.trackEvent('Session', 'activation-success');
            $scope.state.activateUser.requestSuccess = true;
            toastr.success('Account activated successfully! Please login.', 'Success');
            $rootScope.authFailureOccurred = false;
            $scope.state.activateUser.password = '';
            $scope.state.activateUser.passwordConfirmation = '';
            HardNavigationService.navigateTo('enter', true);
            return response;
          }, function() {
            $scope.state.activateUser.requestInvalid = true;
            toastr.error('Account activation did not succeed. Try copying the link out of your activation email.', 'Error');
            $scope.state.activateUser.password = '';
            $scope.state.activateUser.passwordConfirmation = '';
          });
      } else {
        toastr.error('Password\'s must match. Please confirm that they match.', 'Error');
      }

    };


    // if it ever gets cleared then clear the username from localStorage
    $scope.saveEmailStateChanged = function() {
      if (!$scope.state.login.saveEmail) {
        Session.clearEmailForLogin();
      }
    };
  });
